import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.isLoading) return <div className="page-centre"><div className="spinner spinner--large"/><p>Opening AccheyRishtey…</p></div>;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
